import './styles.scss';
//стили копировали себе и используем напрямую, а не как в доке react-slick, т.к.
//не хочется грузить стили в html безусловно (даже на страницах бес слайдера), а второй вариант
// подключения стилей требует jquery в подключаемой зависимости slick-carousel

export { default } from 'react-slick';